/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * How an offer position is billed („Abrechnung“). The free-form
FacilityFlow.Core.Modules.Offers.Entities.OfferPositionEntity.Interval text is description only; when a scheduled
kind is billed comes from the position's own FacilityFlow.Core.Modules.Offers.Entities.PositionBillingRule (FAFD-27).
The numeric values are a wire/persistence contract — never renumber existing members.
 */
export type FacilityFlowCoreModulesOffersEntitiesPositionRecurrenceKind = typeof FacilityFlowCoreModulesOffersEntitiesPositionRecurrenceKind[keyof typeof FacilityFlowCoreModulesOffersEntitiesPositionRecurrenceKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesOffersEntitiesPositionRecurrenceKind = {
  Unknown: 'Unknown',
  Monthly: 'Monthly',
  OneOff: 'OneOff',
  Quarterly: 'Quarterly',
  Yearly: 'Yearly',
  ByEffort: 'ByEffort',
} as const;
